import React, { useState, useEffect } from 'react'
import {
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CImg,
  CLink,
} from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { isLoggedIn } from '../auth'
import iconAvatar from '../assets/icons/user7.png';
import { useKeycloak } from '@react-keycloak/web';
import { useAuth } from '../context/auth';
//import { REACT_APP_API_BACKEND } from '../data/data';
import api from 'src/services/api';

const TheHeaderDropdown = () => {
  const { keycloak, initialized } = useKeycloak();
  const { userAuth, setUserMenu } = useAuth();
  const [ menuAdmin, setMenuAdmin] = useState();
   
  const tryLogoff = () => {
    keycloak.logout()
    if (isLoggedIn()) {
      localStorage.removeItem('@efw/user');
      document.location.reload(true);
    }
  }

  useEffect(() => {
    // só executa se userAuth existir
      api.get(`/user/menus?userID=${userAuth.userID}`)
        .then(res => {
            const menus = res.data;
            setMenuAdmin(menus.filter(c=>c.menuID == 9001)); // salva apenas os menus de configuração
            setUserMenu(menus); // atualiza todos os menus desse usuario
        })
        .catch(err => {
          console.error("Erro ao carregar menus de configurações:", err);
        });
  }, [userAuth?.clientID, userAuth?.reloadMenu]);

  return (
    <CDropdown
      inNav
      className="c-header-nav-items mx-2"
      direction="down"
    >
      <CDropdownToggle className="c-header-nav-link" caret={false}>
        <div className="c-avatar">
          <CImg
            //src={'avatars/5.jpg'}
            src={iconAvatar}
            className="c-avatar-img"
            alt="contato@efwsolutions.com"
          />
        </div>
      </CDropdownToggle>
      <CDropdownMenu className="pt-0" placement="bottom-end">
        <CDropdownItem
          header
          tag="div"
          color="light"
          className="text-center"
        >
          <strong>Configurações</strong>
        </CDropdownItem>
        <CDropdownItem>
          <CIcon name="cil-user" className="mfe-2" />Perfil
        </CDropdownItem>
        <CDropdownItem>
            <CIcon name="cil-settings" className="mfe-2" />
            Configuração
        </CDropdownItem>
        {menuAdmin && menuAdmin.length > 0 && (
          menuAdmin[0].parentMenus.map((menu, index) => (
            <CDropdownItem key={index}>
              <CLink to={menu.route}>   
                <CIcon name={`${index == 0 ?  'cil-laptop' : 'cil-options'}`} className="mfe-2" />
                {menu.name}
              </CLink>
            </CDropdownItem>
          ))
        )}
        <CDropdownItem divider />
        <CDropdownItem onClick={() => tryLogoff()} >
          <CIcon name="cil-lock-locked" className="mfe-2" />
          Sair
        </CDropdownItem>
      </CDropdownMenu>
    </CDropdown>
  )
}

export default TheHeaderDropdown
